const initialState = {
  wrongCredentials: false,
  isLogin: false,
  loginUserId: "",
  isFilled: 0,
  isFetchingFilledStatus: false,
  userPackage : 0,
  isFetchingChangePassword: false,
  wrongPassword: false,
};

const userAccountReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOGIN_ADMIN_SUCCESS":
      return { ...state, 
        isLogin: true, 
        loginUserId: action.payload.user_id,
        userPackage :  localStorage.getItem("up")
      };
    case "LOGIN_ADMIN_ERROR":
      return {
        ...state,
        wrongCredentials: true,
        isLogin: false
      };
    case "REQUEST_IS_FILLED":
      return { ...state, isFetchingFilledStatus: true, };
    case "SUCCESS_IS_FILLED":
      return { ...state, isFetchingFilledStatus: false, isFilled: action.payload.is_filled };
    case "ERROR_IS_FILLED":
      return { ...state, isFetchingFilledStatus: false };


    case "REQUEST_CHANGE_PASSWORD":
      return { ...state, isFetchingChangePassword: true, };
    case "SUCCESS_CHANGE_PASSWORD":
      return { ...state, isFetchingChangePassword: false, };
    case "ERROR_CHANGE_PASSWORD":
      return { ...state,
        wrongPassword : true,
         isFetchingChangePassword: false };
    default:
      return state;
  }
};

export default userAccountReducer;
